import { IUserData } from 'Foundation/User/UserContextModels';
import { getBLPortalURL, getArrangeFinancialsUrl, isProd } from 'Foundation/Configurations/GlobalConfiguration';
import globalConfig from 'Data/globalConfig.json';
import { StringHelper } from './StringHelper';

export function getURL(user: IUserData) {
  if (isProd()) return user.isAgent() ? globalConfig.BL.wasPortal.agent.prod : globalConfig.BL.wasPortal.employee.prod;
  else return user.isAgent() ? globalConfig.BL.wasPortal.agent.nonProd : globalConfig.BL.wasPortal.employee.nonProd;
}

export function getPolicyURLByHref(href: string, user: IUserData) {
  return `${getURL(user)}${href}`;
}

export function getPolicyURL(documentNumber: string, policyNumber: string, lob: string, user: IUserData) {
  return `${getURL(user)}/portal/apodNavLinks.do?documentNumber=${encodeURIComponent(
    documentNumber,
  )}&policyNumber=${policyNumber}&agencyNumber=${
    user.selectedStatCodeData.SubStat
  }&lob=${lob}&market=C&fromCustView=YES&fromRecentAct=YES`;
}

export function getClaimURL(claimNumber: string, user: IUserData, agencyCode?: string) {
  let ldapid: string = user.dpecid.split('@')[0];
  if (agencyCode) agencyCode = agencyCode.split('/')[0].trim();
  return `${getBLPortalURL(
    user.isAgent(),
  )}/portal/QuickSearch?claimNumber=${claimNumber.trim()}&dashboardFlag=true&handler_name=ClaimStartHandler&lramidkey=${ldapid}&newSearch=Y&agencyNumber=${
    agencyCode ?? user.selectedStatCodeData.SubStat
  }&application=claims&searchString=${claimNumber.trim()}`;
}

export async function getBillingURLByPolicy(policyNumber: string, agencyCode: string, user: IUserData) {
  //for recent activities pass in agency number from the recent activity instead of that aligned to user
  let response = await fetch(
    `/api/sitecore/BillingAsync/GetRedirectURL?agencyNumber=${agencyCode}&policyNumber=${policyNumber}`,
  );
  let result = await response.json();

  if (result && result.length == 1 && result[0].indexOf(getArrangeFinancialsUrl()) !== -1 && !user.isAgent())
    return [result[0].replace('libertymutual', 'lmig')]; //arrange financials

  if (result && result.length) return result; //majesco or multiple billing accounts
  else return [];
}

export async function getMajescoBillingURLByPolicy(policyNumber: string, agencyCode: string) {
  let policyURL = '';
  try {
    let response = await fetch(
      `/api/sitecore/BillingAsync/GetRedirectURL?agencyNumber=${agencyCode}&policyNumber=${policyNumber}`,
    );
    let result = await response.json();
    if (result && result.length) {
      let urls = result.filter((res: string) => res.indexOf(getArrangeFinancialsUrl()) === -1);
      policyURL = urls[0];
    }
  } catch (Exception) {}
  return policyURL;
}

export async function getBillingURLByAccount(user: IUserData, account: string) {
  //when we have account number and no agency code, pass in agency number from user
  let response = await fetch(
    `/api/sitecore/BillingAsync/GetRedirectURL?agencyNumber=${user.selectedStatCodeData.SubStat}&account=${account}`,
  );
  let result = await response.json();
  if (result && result[0] && result[0].indexOf(getArrangeFinancialsUrl()) !== -1 && !user.isAgent())
    return result[0].replace('libertymutual', 'lmig'); //arrange financials
  else if (result && result.length) return result[0]; //majesco
  else return null;
}

export const populateTokens = (links: INavigationLink[], userData: IUserData) => {
  for (let i: number = 0; i < links.length; i++) {
    if (links[i]?.Link?.Url) {
      links[i].Link.Url = StringHelper.replaceTokens(links[i].Link.Url, userData);
    }
  }
  return links;
};

